/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Dvc_Search_Type_PlaceholderInputs */

const en_task_dvc_search_type_placeholder = /** @type {(inputs: Task_Dvc_Search_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a search type`)
};

const pt_br2_task_dvc_search_type_placeholder = /** @type {(inputs: Task_Dvc_Search_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o tipo de consulta`)
};

/**
* | output |
* | --- |
* | "Select a search type" |
*
* @param {Task_Dvc_Search_Type_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_dvc_search_type_placeholder = /** @type {((inputs?: Task_Dvc_Search_Type_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Dvc_Search_Type_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_dvc_search_type_placeholder(inputs)
	return pt_br2_task_dvc_search_type_placeholder(inputs)
});